import { render, staticRenderFns } from "./ownClassCat.vue?vue&type=template&id=4dde079e&scoped=true&"
import script from "./ownClassCat.vue?vue&type=script&lang=js&"
export * from "./ownClassCat.vue?vue&type=script&lang=js&"
import style0 from "./ownClassCat.vue?vue&type=style&index=0&id=4dde079e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dde079e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
